import { defineAsyncComponent } from 'vue'
export default {
  "nav-admin": defineAsyncComponent(() => import("/work/release/fe-oj-monorepo-hetao/packages/core/layouts/NavAdmin.vue").then(m => m.default || m)),
  "nav-oj": defineAsyncComponent(() => import("/work/release/fe-oj-monorepo-hetao/packages/core/layouts/NavOj.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/work/release/fe-oj-monorepo-hetao/packages/core/layouts/default.vue").then(m => m.default || m))
}